import { features } from "@/mocks/banana";

export default function Features() {
  return (
    <section id="features" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-800">
            <i className="ri-rocket-line" />
            核心功能
          </span>
          <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">
            为什么选择香蕉漫画
          </h2>
          <p className="mt-3 text-base text-foreground-600">
            从离线阅读到多端同步，每一处细节都为漫画爱好者精心打磨。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((f) => (
            <article
              key={f.title}
              className="group rounded-2xl border border-background-200 bg-background-50 p-6 transition-all hover:-translate-y-1 hover:border-primary-200"
            >
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${f.icon} text-2xl`} />
              </span>
              <h3 className="mt-5 text-lg font-semibold text-foreground-950">
                {f.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {f.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}